import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Navbar          from './components/Navbar';
import Footer          from './components/Footer';
import Home            from './components/Home';
import About           from './components/About';
import Enquiry         from './components/Enquiry';
import Exam            from './components/Exam';
import Faculty         from './components/Faculty';
import Gallery         from './components/Gallery';
import Testimony       from './components/Testimony';
import WriteTestimony  from './components/WriteTestimony';
import Login           from './components/Login';
import AdminDash       from './components/AdminDash';
import CoursesSSC      from './components/CoursesSSC';
import CoursesCBSE     from './components/CoursesCBSE';
import CoursesScience  from './components/CoursesScience';
import CoursesCommerce from './components/CoursesCommerce';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        {/* ── Main Pages ─────────────────────────────────────── */}
        <Route path="/"            element={<Home />} />
        <Route path="/about"       element={<About />} />
        <Route path="/enquiry"     element={<Enquiry />} />
        <Route path="/exam"        element={<Exam />} />
        <Route path="/faculty"     element={<Faculty />} />
        <Route path="/gallery"     element={<Gallery />} />
        <Route path="/testimony"   element={<Testimony />} />
        <Route path="/writetestimony" element={<WriteTestimony />} />
        <Route path="/login"       element={<Login />} />
        <Route path="/admin"       element={<AdminDash />} />

        {/* ── SEO-Friendly Course URLs (primary) ─────────────── */}
        <Route path="/ssc-coaching-ulhasnagar-kalyan"      element={<CoursesSSC />} />
        <Route path="/cbse-coaching-ulhasnagar-kalyan"     element={<CoursesCBSE />} />
        <Route path="/science-coaching-ulhasnagar-kalyan"  element={<CoursesScience />} />
        <Route path="/commerce-classes-ulhasnagar-kalyan"  element={<CoursesCommerce />} />

        {/* ── Legacy URLs → redirect to SEO URLs ─────────────── */}
        <Route path="/courses_ssc"      element={<Navigate to="/ssc-coaching-ulhasnagar-kalyan" replace />} />
        <Route path="/courses_cbse"     element={<Navigate to="/cbse-coaching-ulhasnagar-kalyan" replace />} />
        <Route path="/courses_science"  element={<Navigate to="/science-coaching-ulhasnagar-kalyan" replace />} />
        <Route path="/courses_commerce" element={<Navigate to="/commerce-classes-ulhasnagar-kalyan" replace />} />

        {/* ── Keyword alias URLs (extra SEO coverage) ────────── */}
        <Route path="/best-classes-5-to-10-state-board"   element={<CoursesSSC />} />
        <Route path="/cbse-classes-5-to-10"               element={<CoursesCBSE />} />
        <Route path="/jee-coaching-ulhasnagar"            element={<CoursesScience />} />
        <Route path="/neet-coaching-ulhasnagar"           element={<CoursesScience />} />
        <Route path="/mhtcet-coaching-ulhasnagar"         element={<CoursesScience />} />
        <Route path="/commerce-classes-11-12"             element={<CoursesCommerce />} />
        <Route path="/best-commerce-classes-ulhasnagar"   element={<CoursesCommerce />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
